import { useCookies } from 'react-cookie'
import { makeIgnoredStepsKey } from '../../helpers'

type Props = {
  categoryId: string
}

export const useIgnoreAssessmentStep = ({ categoryId }: Props) => {
  const [cookies, setCookies] = useCookies([makeIgnoredStepsKey(categoryId)])

  const ignoredSteps = cookies?.[makeIgnoredStepsKey(categoryId)] || []

  const addIgnoredStep = (step: string) => {
    if (!ignoredSteps.includes(step)) {
      setCookies(makeIgnoredStepsKey(categoryId), [...ignoredSteps, step], {
        path: '/',
      })
    }
  }

  const removeIgnoredStep = (step: string) => {
    if (ignoredSteps.includes(step)) {
      setCookies(
        makeIgnoredStepsKey(categoryId),
        ignoredSteps.filter((stepToRemove: string) => stepToRemove !== step),
        { path: '/' },
      )
    }
  }

  return {
    ignoredSteps,
    addIgnoredStep,
    removeIgnoredStep,
  }
}
